import gql from 'graphql-tag';

export const setAdvStatusMutation = gql`
    mutation setAdvStatusMutation($id: ID!, $status: Status360!) {
        results: advSetStatus(id: $id, newStatus: $status) {
            id
            status
        }
    }
`;
